export enum EndpointsEnum {
    POST_TICKET_CHAT = '/report/chat',
    POST_TICKET_CHAT_MESSAGE = '/report/chat-message',
    POST_TICKET_ROOM = '/report/room',
    POST_TICKET_ROOM_MESSAGE = '/report/room-message',
    POST_TICKET_USER = '/report/user',
    POST_CONTACT = '/contact',
}
